import { Link } from 'react-router-dom';
import { motion } from 'motion/react';

const APP = import.meta.env.VITE_APP_NAME ?? 'ProtoLive Studio';

export default function TermsPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      style={{ height: '100dvh', overflowY: 'auto', WebkitOverflowScrolling: 'touch', backgroundColor: 'var(--bg)' }}
    >
      <article style={{ maxWidth: 720, margin: '0 auto', padding: '24px 18px', fontSize: 15, lineHeight: 1.55 }}>
        <p><Link to="/">← back</Link></p>
        <h1 style={{ fontSize: 18, marginBottom: 6 }}>terms of service</h1>
        <p style={{ color: 'var(--fg-dim)', marginBottom: 18 }}>Last updated: 2026-05-21</p>

        <p>By using <strong>{APP}</strong> you agree to these terms.</p>

        <h3>Your account and your keys</h3>
        <p>{APP} is a bring-your-own-key tool. You are responsible for the API keys
        you enter and for any usage costs they incur with the underlying providers
        (Google, OpenAI, BytePlus, xAI). Keep your keys secret. Revoke them at the
        provider if you suspect they are compromised.</p>

        <h3>Acceptable use</h3>
        <p>You may not use {APP} to generate, edit, or distribute content that:</p>
        <ul>
          <li>depicts minors in any sexualized context</li>
          <li>depicts non-consensual sexual content or impersonates a real person
            in a way that defames, harasses, or deceives</li>
          <li>promotes violence, terrorism, or self-harm</li>
          <li>infringes intellectual property you do not have the right to use</li>
          <li>violates the terms of any provider used through the app</li>
        </ul>
        <p>The model providers also enforce their own policies and may refuse or
        revoke requests on that basis.</p>

        <h3>Generated content</h3>
        <p>You retain rights in the content you generate to the extent permitted by
        the underlying provider's terms. Generated outputs may be unique to your
        prompts but cannot be guaranteed to be original or non-infringing; review
        outputs before publishing.</p>

        <h3>Service availability</h3>
        <p>{APP} is provided as-is. We do not guarantee uptime, output quality, or
        compatibility with any particular provider. Provider APIs change and may
        break specific features without notice.</p>

        <h3>No warranty / liability cap</h3>
        <p>To the maximum extent permitted by law, {APP} and the operator of this
        deployment disclaim all warranties and are not liable for indirect,
        incidental, or consequential damages. Total liability is limited to the
        fees you have paid us in the prior twelve months, which is zero in the
        default BYOK configuration.</p>

        <h3>Termination</h3>
        <p>You may stop using {APP} at any time by clearing local data and signing
        out of any cloud account. We may suspend or terminate access to abusive
        users.</p>

        <h3>Changes</h3>
        <p>We may update these terms. Continued use after an update constitutes
        acceptance.</p>
      </article>
    </motion.div>
  );
}
